import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useToastError } from "@/components/ui/use-toast";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { TeamBillingPortalDTO } from "@shaarp/common";
import { AlertTriangleIcon } from "lucide-react";
import { useState } from "react";

/**
 * Red alert banner displayed when the team has a payment failure.
 * Provides a CTA to open the Stripe billing portal to fix the payment method.
 */
export const BannerPaymentFailed = () => {
  const { t } = useTranslation();
  const api = useApi();
  const toastError = useToastError();

  const [isLoading, setIsLoading] = useState(false);

  const openPortal = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get<TeamBillingPortalDTO>(
        "/my/team/billing/portal"
      );
      if (data?.url) window.open(data.url, "_blank")?.focus();
    } catch {
      toastError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Alert variant="destructive">
      <AlertTriangleIcon className="w-4 h-4" />
      <AlertTitle>{t("team.page.paymentWarning.title")}</AlertTitle>
      <AlertDescription>
        {t("team.page.paymentWarning.description")}{" "}
        <button
          type="button"
          className="underline font-medium disabled:opacity-50"
          onClick={openPortal}
          disabled={isLoading}
        >
          {isLoading
            ? t("team.components.billingPortalButton.loading")
            : t("team.components.billingPortalButton.defaultText")}
        </button>
      </AlertDescription>
    </Alert>
  );
};
